import { render, staticRenderFns } from "./UserTaskProps.vue?vue&type=template&id=d7fd511c"
import script from "./UserTaskProps.vue?vue&type=script&lang=js"
export * from "./UserTaskProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports